export default __webpack_public_path__ + "images/40310b88e71939f4c46f37e3ca97eef2-vision-board.svg";